export const prepareSqlOptionFields = (formData) => {
   if (!formData?.tab) return;

   const normalizeSqlOption = (sqlOption) => {
      if (!sqlOption || typeof sqlOption !== "object") return null;

      // Extract label and value, with fallbacks
      const label = sqlOption.label ?? sqlOption.value ?? "";
      const value = sqlOption.value ?? sqlOption.label ?? "";

      // If both are missing, skip this option
      if (!label && !value) return null;

      return {
         value: value,
         label: label,
      };
   };

   formData.tab.forEach((tab) => {
      if (!tab?.elements) return;

      Object.values(tab.elements).forEach((element) => {
         if (!element?.sqlValues?.length) return;

         const seenValues = new Set();
         const normalizedOptions = [];

         element.sqlValues.forEach((sqlOption) => {
            const normalized = normalizeSqlOption(sqlOption);
            if (normalized && !seenValues.has(normalized.label)) {
               seenValues.add(normalized.label);
               normalizedOptions.push(normalized);
            }
         });

         element.sqlValues = normalizedOptions;
      });
   });
};
